import { useModal, Dialog, Button, Text } from '@leroy-merlin-br/backyard-react'

import { createUrlInvoice } from '../../utils/createUrlInvoice'
import * as S from './styled'

type SellersInvoiceModalProps = {
  saleOrderId: string
  sellersInvoice: SellerInvoice[]
}

type SellerInvoice = {
  shopId: number
  accessKey: string
  shopName: string
}

export const SellersInvoiceModal = (
  sellersInvoiceModalProps: SellersInvoiceModalProps
) => {
  const { saleOrderId, sellersInvoice } = sellersInvoiceModalProps
  const { setModal } = useModal()

  const handleButtonClick = (accessKey: string) => {
    const url = createUrlInvoice(accessKey)

    window.open(url, '_blank')
  }

  const showModal = () => {
    if (sellersInvoice && sellersInvoice.length <= 1) {
      const [invoice] = sellersInvoice

      if (invoice?.accessKey) {
        const url = createUrlInvoice(invoice.accessKey)
        window.open(url, '_blank')
      }

      return
    }

    setModal({
      onClose: () => true,
      children: ({ onClose }) => (
        <Dialog
          title="Visualizar a Nota Fiscal"
          footer={
            <S.ButtonStyle>
              <Button
                appearance="critical"
                onClick={onClose}
                variant="link"
                size="mega">
                Fechar
              </Button>
            </S.ButtonStyle>
          }>
          <Text>
            Você possui produtos de vendedores diferentes em seu pedido{' '}
            <strong>{saleOrderId}</strong>. Clique no vendedor para acessar a
            Nota Fiscal.
          </Text>

          {sellersInvoice.map(sellerInvoice => (
            <S.LinkSellerInvoice
              key={sellerInvoice.accessKey}
              onClick={() => handleButtonClick(sellerInvoice.accessKey)}>
              <Text color="g600" decoration="underline">
                {sellerInvoice.shopName ?? sellerInvoice.accessKey}
              </Text>
            </S.LinkSellerInvoice>
          ))}

          <Text isBold size="kilo">
            A Nota Fiscal de produtos vendidos e entregues pela Leroy Merlin é
            encaminhada para seu e-mail
          </Text>
        </Dialog>
      )
    })
  }

  return (
    <a className="invoice-button" onClick={showModal}>
      Acessar Nota Fiscal
    </a>
  )
}
